import _ButtonBase from "@mui/material/ButtonBase";
import _Add from "@mui/icons-material/Add";
import _IconButton from "@mui/material/IconButton";
import _Close from "@mui/icons-material/Close";
import _Box from "@mui/material/Box";
import _Typography from "@mui/material/Typography";
import { lighten } from '@mui/material/styles';
import React, { useEffect, useRef, useState } from 'react';
export function ImageInput({
  file,
  onChange
}) {
  const [value, setValue] = useState('');
  const [previewUrl, setPreviewUrl] = useState();
  const inputRef = useRef(null);
  useEffect(() => {
    if (file) {
      if ('url' in file) setPreviewUrl(file.url);else if (file instanceof File) setPreviewUrl(URL.createObjectURL(file));
    } else {
      setPreviewUrl(undefined);
    }
  }, [file]);
  function handleChange({
    target: {
      value,
      files
    }
  }) {
    setValue(value);
    const newFile = files?.[0];
    if (newFile && newFile.size > 2_000_000) {
      alert("L'image est trop lourde");
      setValue('');
      return;
    }
    if (newFile) setPreviewUrl(URL.createObjectURL(newFile));
    onChange(newFile || file);
  }
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("input", {
    accept: "image/*",
    onChange: handleChange,
    onClick: ({
      currentTarget
    }) => currentTarget.value = '',
    ref: inputRef,
    style: {
      display: 'none'
    },
    type: "file",
    value: value
  }), /*#__PURE__*/React.createElement(_Box, {
    alignItems: "flex-start",
    display: "flex",
    gap: 2
  }, /*#__PURE__*/React.createElement(_Box, {
    flexGrow: 1
  }, /*#__PURE__*/React.createElement(_Typography, {
    variant: "body2"
  }, "Privil\xE9giez une image au format paysage avec une largeur sup\xE9rieure \xE0 1500 pixels. La taille maximale par fichier est de 2 Mo.")), /*#__PURE__*/React.createElement(_Box, {
    flexShrink: 0,
    width: 200
  }, previewUrl ? /*#__PURE__*/React.createElement(_Box, {
    position: "relative"
  }, /*#__PURE__*/React.createElement("img", {
    src: previewUrl,
    style: {
      borderRadius: 8
    },
    width: "100%"
  }), /*#__PURE__*/React.createElement(_Box, {
    position: "absolute",
    right: 8,
    top: 8
  }, /*#__PURE__*/React.createElement(_IconButton, {
    onClick: () => onChange(null),
    size: "small",
    sx: {
      bgcolor: '#326AC2',
      color: '#fff',
      '&:hover': {
        bgcolor: lighten('#326AC2', 0.1)
      }
    }
  }, /*#__PURE__*/React.createElement(_Close, null)))) : /*#__PURE__*/React.createElement(_ButtonBase, {
    onClick: () => inputRef.current?.click(),
    sx: {
      alignItems: 'center',
      bgcolor: '#528BE8',
      borderRadius: 2,
      color: '#fff',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'center',
      minHeight: 100,
      padding: 2,
      gap: 1,
      width: '100%'
    }
  }, /*#__PURE__*/React.createElement(_Box, {
    bgcolor: "#326AC2",
    borderRadius: 3,
    height: 24,
    width: 24
  }, /*#__PURE__*/React.createElement(_Add, null)), /*#__PURE__*/React.createElement(_Typography, {
    align: "center",
    variant: "body2"
  }, "Ajouter une image")))));
}